import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function LoginPage() {
  return (
    <div className="min-h-screen bg-surface-dim flex items-center justify-center p-6 transition-colors duration-500">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/" className="inline-block mb-4">
             <span className="font-label-caps text-[14px] text-primary uppercase tracking-[0.3em] font-bold">DocForge</span>
          </Link>
          <h1 className="font-h1 text-h1 text-on-surface mb-2">Access the Scriptorium</h1>
          <p className="font-body-md text-body-md text-on-surface-variant italic">Enter your credentials to resume your work.</p>
        </div>

        <div className="bg-surface border border-outline-variant rounded-2xl p-8 md:p-10 shadow-2xl ink-drop-shadow relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-primary/20"></div>
          
          <form className="space-y-6">
            <div className="space-y-2">
              <label className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block" htmlFor="email">
                Email Address
              </label>
              <input 
                type="email" 
                id="email" 
                placeholder="scribe@docforge.ai"
                className="w-full bg-surface-container-low border border-outline-variant rounded-lg px-4 py-3 font-body-md text-on-surface focus:outline-none focus:ring-1 focus:ring-primary transition-all"
              />
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <label className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block" htmlFor="password">
                  Password
                </label>
                <Link to="/forgot-password" title="Recover Password" className="text-[10px] font-label-caps text-primary uppercase tracking-widest hover:underline">
                  Forgot?
                </Link>
              </div>
              <input 
                type="password" 
                id="password" 
                placeholder="••••••••"
                className="w-full bg-surface-container-low border border-outline-variant rounded-lg px-4 py-3 font-body-md text-on-surface focus:outline-none focus:ring-1 focus:ring-primary transition-all"
              />
            </div>

            <button className="w-full bg-primary text-on-primary py-4 rounded-lg font-label-caps text-label-caps uppercase tracking-widest shadow-lg hover:shadow-primary/20 transition-all active:translate-y-px">
              Sign In to Scriptorium
            </button>
          </form>

          <div className="mt-8 pt-8 border-t border-outline-variant/30 text-center">
            <span className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block mb-4">Or continue with</span>
            <div className="grid grid-cols-2 gap-4">
               <button className="flex items-center justify-center gap-3 bg-surface border border-outline-variant py-3 rounded-lg hover:bg-surface-container-high transition-colors">
                  <img src="https://www.google.com/favicon.ico" className="w-4 h-4 grayscale group-hover:grayscale-0" alt="Google" />
                  <span className="font-label-caps text-[10px] uppercase tracking-widest">Google</span>
               </button>
               <button className="flex items-center justify-center gap-3 bg-surface border border-outline-variant py-3 rounded-lg hover:bg-surface-container-high transition-colors">
                  <span className="material-symbols-outlined text-[18px]">terminal</span>
                  <span className="font-label-caps text-[10px] uppercase tracking-widest">GitHub</span>
               </button>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="font-body-md text-on-surface-variant text-sm">
            Not yet registered? <Link to="/signup" className="text-primary font-bold hover:underline">Join the Guild</Link>
          </p>
        </div>
        
        <footer className="mt-12 text-center space-x-6">
           <Link to="/terms" className="font-label-caps text-[9px] text-on-surface-variant uppercase tracking-widest hover:text-primary transition-colors">Terms</Link>
           <Link to="/privacy" className="font-label-caps text-[9px] text-on-surface-variant uppercase tracking-widest hover:text-primary transition-colors">Privacy</Link>
           <Link to="/cookies" className="font-label-caps text-[9px] text-on-surface-variant uppercase tracking-widest hover:text-primary transition-colors">Cookies</Link>
        </footer>
      </div>
    </div>
  );
}
